import { getApiClient } from "@healthos/api-client";
import type { AppType } from "@healthos/core-api";
import { hc } from "hono/client";

// Error handling is single-sourced in @healthos/client-data so web and mobile
// throw the same ApiError (status, code, userMessage) from every transport.
export {
  ApiError,
  jsonOrNull,
  jsonOrThrow,
  userFacingApiErrorMessage,
} from "@healthos/client-data";

export function client() {
  const { fetch: f, baseUrl } = getApiClient();
  return hc<AppType>(baseUrl ?? "", { fetch: f });
}

export function apiBaseUrl(): string {
  return getApiClient().baseUrl ?? "";
}

export function absoluteApiUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  const base = apiBaseUrl().replace(/\/$/, "");
  return base ? `${base}${path}` : path;
}
